module.exports = __webpack_public_path__ + "img/logo.3f4429be.png";